import {
  FilterValueComplex,
  FilterQueryParamOperator,
  BaseFilter,
  FilterControlType,
} from '../filter.types';
import { BaseFilterClass } from '../BaseFilterClass';
import { Observable, of } from 'rxjs';

export class FilePurposeFilter
  extends BaseFilterClass
  implements BaseFilter<FilterValueComplex[]>
{
  constructor({
    urlQueryParam = 'file_purpose_id',
    urlQueryParamOperator = FilterQueryParamOperator.OperatorEq,
    quickSearchLabel = 'Purpose',
    quickSearchPrefixes = ['Purpose', 'p'],
    quickSearchAutocompleteExclusionRegExp = /^\w/i,
    htmlLabel = 'Purpose',
    htmlElementId = 'file_purpose_id',
    placeholder = 'Select a Purpose',
    filterControlType = FilterControlType.FilterControlTypeSelect,
  } = {}) {
    super();

    this.setURLQueryParam(urlQueryParam);
    this.setURLQueryParamOperator(urlQueryParamOperator);
    this.setQuickSearchLabel(quickSearchLabel);
    this.setQuickSearchPrefixes(quickSearchPrefixes);
    this.setQuickSearchAutocompleteRegExp(
      quickSearchAutocompleteExclusionRegExp
    );
    this.setHTMLLabel(htmlLabel);
    this.setHTMLElementId(htmlElementId);
    this.setPlaceholder(placeholder);
    this.setFilterControlType(filterControlType);
  }

  override loadFilterData(): Observable<FilterValueComplex[]> {
    const purposeOptions: FilterValueComplex[] = [
      { filter_label: 'View All', filter_value: '' },
      { filter_label: 'Other', filter_value: '1' },
      { filter_label: 'Bond', filter_value: '2' },
      { filter_label: 'Blank Bond Form', filter_value: '3' },
      { filter_label: 'Rider', filter_value: '4' },
      { filter_label: 'Continuation Certificate', filter_value: '5' },
      { filter_label: 'Application (Signed)', filter_value: '6' },
      { filter_label: 'Application (Unsigned)', filter_value: '7' },
      { filter_label: 'Finance Agreement (Signed)', filter_value: '8' },
      { filter_label: 'Finance Agreement (Unsigned)', filter_value: '9' },
      { filter_label: 'Agent Package', filter_value: '10' },
      { filter_label: 'Credit Report', filter_value: '11' },
      { filter_label: 'Application Documentation', filter_value: '12' },
      { filter_label: 'Quote Documentation', filter_value: '13' },
      { filter_label: 'Financial Statement', filter_value: '14' },
      { filter_label: 'Notice of Cancellation', filter_value: '15' },
      { filter_label: 'Project Contract', filter_value: '16' },
      { filter_label: 'Court Documents', filter_value: '17' },
      { filter_label: 'Obligee Release', filter_value: '18' },
      { filter_label: 'Receipt', filter_value: '19' },
      { filter_label: 'Shipping Label', filter_value: '20' },
      { filter_label: 'API', filter_value: '21' },
      { filter_label: 'Attachment', filter_value: '22' },
    ];

    this.setValue(purposeOptions);

    return of(purposeOptions);
  }
}
